import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumExternalOrderStatus implements BaseEnumType {
  private static allValues: EnumExternalOrderStatus[] = []; // make sure this is top-most
  
  public static newOrder = new EnumExternalOrderStatus(0, "NewOrder", "enum_external_order_status_new_order");
  public static inBrewMan = new EnumExternalOrderStatus(1, "InBrewMan", "enum_external_order_status_in_brew_man");
  public static delivered = new EnumExternalOrderStatus(2, "Delivered", "enum_external_order_status_delivered");
  public static complete = new EnumExternalOrderStatus(3, "Complete", "enum_external_order_status_complete");
  public static releasedToBrewMan = new EnumExternalOrderStatus(4, "ReleasedToBrewMan", "enum_external_order_status_released_to_brew_man");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumExternalOrderStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNewOrder() { return this === EnumExternalOrderStatus.newOrder; }
  public isInBrewMan() { return this === EnumExternalOrderStatus.inBrewMan; }
  public isDelivered() { return this === EnumExternalOrderStatus.delivered; }
  public isComplete() { return this === EnumExternalOrderStatus.complete; }
  public isReleasedToBrewMan() { return this === EnumExternalOrderStatus.releasedToBrewMan; }

  public static getValues(): readonly EnumExternalOrderStatus[] {
    return EnumExternalOrderStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumExternalOrderStatus[] {
    return EnumExternalOrderStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumExternalOrderStatus {
    const found = EnumExternalOrderStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumExternalOrderStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumExternalOrderStatus): EnumExternalOrderStatus {
    const found = name ? EnumExternalOrderStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumExternalOrderStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumExternalOrderStatus>): boolean {
    return this.key === other?.key;
  }
}